module.exports = __webpack_public_path__ + "img/three-dots.84e2b3aa.svg";